// extracted by mini-css-extract-plugin
module.exports = {"containerBox":"styles_containerBox__2Pzgt","primary":"styles_primary__3M1kM","secondary":"styles_secondary__1WNJ7"};